import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrganisationOption } from '../../models/forms/user-form';

@Component({
    selector: 'app-selected-organisations-panel',
    templateUrl: './selected-organisations-panel.component.html',
    styleUrls: ['./selected-organisations-panel.component.sass'],
    standalone: false
})
export class SelectedOrganisationsPanelComponent {
  @Input() items: OrganisationOption[] = [];
  @Output() itemClicked: EventEmitter<number> = new EventEmitter();

  onClick(idx: number) {
    this.itemClicked.emit(idx);
  }
}
